import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { BackendResponse, Phone, Staff, entityName } from '@qtek/shared/models';
import { getGMTOffset } from '@qtek/shared/utils';
import { HttpEntityManager } from './../http-entity-manager';

@Injectable({
  providedIn: 'root',
})
export class StaffService extends HttpEntityManager<Staff, Staff> {
  protected http = inject(HttpClient);

  entityName: entityName = 'User';

  constructor() {
    super();
  }

  getStaff(params?: {
    includeMyself?: boolean;
    excludeAlreadyInvitedToItemId?: boolean;
  }) {
    return this.http.get<BackendResponse>('/api/v2/model/User', {
      withCredentials: true,
      params,
    });
  }

  createEmployee(employee: Staff) {
    return super.post(employee, undefined, {
      gmtOffset: getGMTOffset(),
      tzGuess: btoa(Intl.DateTimeFormat().resolvedOptions().timeZone),
      _snd: 'email',
    });
  }

  deleteStaffInfo(relId: string) {
    return super.delete(btoa(relId), {
      tp: 'val',
    });
  }

  deleteStaff(id: string) {
    return super.delete(id);
  }

  updateStaff(payload: Partial<Staff>, usrId: string) {
    return super.put(payload, usrId);
  }

  updateStaffPhone(payload: { userId: string; phone: Phone }) {
    return this.http.put<BackendResponse<string>>(
      '/api/v2/user/update-phone-number',
      payload,
      this.baseRequestOptions
    );
  }

  sendInvitation(userId: string) {
    return this.http.post<BackendResponse>(
      `/api/v2/user/resend-invitation/${userId}`,
      undefined,
      this.baseRequestOptions
    );
  }
}
